import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff7ff2fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "shadow-lg border border-primary-50 dark:text-dark-text dark:bg-dark-800 dark:border-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_2 = {
  class: "bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700",
  style: {"border-top-right-radius":"1rem","border-top-left-radius":"1rem"}
}
const _hoisted_3 = { class: "commentary-top flex no-select mx-2" }
const _hoisted_4 = { class: "flex items-center justify-center text-white dark:text-dark-text" }
const _hoisted_5 = { class: "text-2xl material-icons mr-2" }
const _hoisted_6 = { class: "text-lg font-bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_8 = { class: "commentary-bottom" }
const _hoisted_9 = ["id"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.icon), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getTitle(_ctx.commentary.type)), 1)
        ]),
        _hoisted_7,
        _createVNode(_component_DropDown, {
          class: "items-center justify-center",
          itemList: _ctx.commentary.filter,
          selected: _ctx.selectCommentary,
          selectedIndex: _ctx.selectedIndex
        }, null, 8, ["itemList", "selected", "selectedIndex"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        id: _ctx.idBinder(_ctx.commentary),
        class: _normalizeClass(["mb-3", _ctx.isLightMode() ? 'description' : 'description-dark'])
      }, null, 10, _hoisted_9),
      _hoisted_10
    ])
  ]))
}